"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _getColorBgImg = _interopRequireDefault(require("./utils/getColorBgImg"));
var _makeStyle = _interopRequireDefault(require("./utils/makeStyle"));
var _excluded = ["color", "style", "className", "dark", "size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyle = (0, _makeStyle.default)('ColorPreview', function () {
  return {
    '.previewer-color-preview': {
      position: 'relative',
      borderRadius: '50%',
      padding: 0,
      display: 'inline-block',
      '&::before': {
        content: '""',
        width: '100%',
        height: '100%',
        borderRadius: '50%',
        top: 0,
        insetInlineStart: 0,
        position: 'absolute',
        zIndex: 2,
        backgroundColor: 'var(--antd-token-previewer-color-preview)',
        boxShadow: '0 2px 3px -1px rgba(0,0,0,0.20), inset 0 0 0 1px rgba(0,0,0,0.09)'
      }
    }
  };
});
var ColorPreview = function ColorPreview(_ref) {
  var color = _ref.color,
    style = _ref.style,
    className = _ref.className,
    dark = _ref.dark,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 20 : _ref$size,
    restProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var _useStyle = useStyle(),
    _useStyle2 = (0, _slicedToArray2.default)(_useStyle, 2),
    warpSSR = _useStyle2[0],
    hashId = _useStyle2[1];
  return warpSSR( /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, restProps, {
    className: (0, _classnames.default)('previewer-color-preview', className, hashId),
    style: _objectSpread((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, '--antd-token-previewer-color-preview', color), "width", size), "height", size), style)
  }), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      content: '""',
      width: size - 2,
      height: size - 2,
      borderRadius: '50%',
      top: 1,
      insetInlineStart: 1,
      position: 'absolute',
      zIndex: 1,
      background: "".concat((0, _getColorBgImg.default)(dark), " 0% 0% / ").concat(size, "px")
    }
  })));
};
var _default = exports.default = ColorPreview;